import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { HiMenu, HiX } from 'react-icons/hi';

export default function Header() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Sample Work', path: '/work' },
    { name: 'Tools', path: '/tools' },
    { name: 'Contact Us', path: '/contact' },
    { name: 'About Us', path: '/about' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 80 }}
      className="bg-gradient-to-r from-indigo-50 via-white to-pink-100 backdrop-blur-md shadow-md sticky top-0 z-50"
    >
      <nav className="flex justify-between items-center max-w-7xl mx-auto px-4 sm:px-8 py-1 relative z-10">
        {/* <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-pink-500 text-transparent bg-clip-text"
        >
          VP Photography
        </motion.h1> */}
        <Link to="/" className="flex items-center gap-2">
          <motion.img
            src="/images/logo/logo.png" 
            alt="VP Photography Logo"
            className="h-20 w-auto object-contain"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          />
        </Link>


        {/* Desktop Nav */}
        <ul className="hidden sm:flex gap-8 text-base font-medium">
          {navItems.map(({ name, path }) => (
            <motion.li
              key={path}
              whileHover={{ scale: 1.05 }}
              className="relative group"
            >
              <Link
                to={path}
                className={`transition-colors duration-300 ${
                  isActive(path) ? 'text-indigo-600' : 'text-gray-700'
                }`}
              >
                {name}
              </Link>
              <span
                className={`absolute left-0 -bottom-1 h-[2px] w-0 group-hover:w-full transition-all duration-300 ${
                  isActive(path) ? 'bg-indigo-600 w-full' : 'bg-indigo-400'
                }`}
              />
            </motion.li>
          ))}
        </ul>

        {/* Mobile Hamburger */}
        <div className="sm:hidden">
          <button
            onClick={() => setIsMenuOpen((prev) => !prev)}
            className="text-indigo-600 text-3xl focus:outline-none"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <HiX /> : <HiMenu />}
          </button>
        </div>
      </nav>

      {/* Mobile Nav Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="sm:hidden px-4 pb-4 space-y-2 text-center bg-white shadow-md"
          >
            {navItems.map(({ name, path }) => (
              <li key={path}>
                <Link
                  to={path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block py-2 text-lg font-medium transition-colors duration-300 ${
                    isActive(path) ? 'text-indigo-600' : 'text-gray-800'
                  }`}
                >
                  {name}
                </Link>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
